
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cne-tournament-registration",
      function () {
        return require("private-next-pages/cne-tournament-registration/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cne-tournament-registration"])
      });
    }
  